import { required } from "vuelidate/lib/validators";

export default class NaturezaData {
  descricao = "";

  id_empresa = 1;

  cfop = [];

  tributacao = [];

  movimentaEstoque = true;

  calculaIpi = false;

  retencaoPISCOFINSCSLL = false;

  informacoesComplementares = "";

  calculaTributo = true;

  tributacao_revenda = [];

  constructor({
    descricao = "",
    cfop = [],
    tributacao = [],
    movimentaEstoque = true,
    calculaIpi = false,
    retencaoPISCOFINSCSLL = false,
    informacoesComplementares = "",
    calculaTributo = true,
    tributacao_revenda = [],
  }) {
    this.descricao = descricao;
    this.cfop = cfop;
    this.tributacao = tributacao;
    this.movimentaEstoque = movimentaEstoque;
    this.calculaIpi = calculaIpi;
    this.retencaoPISCOFINSCSLL = retencaoPISCOFINSCSLL;
    this.informacoesComplementares = informacoesComplementares;
    this.calculaTributo = calculaTributo;
    this.tributacao_revenda = tributacao_revenda;
  }
}

export const NaturezaDataRequired = {
  descricao: {
    required,
  },
};
